module.exports = __webpack_public_path__ + "img/safe-system.65411948.png";